<template>
  <div>
    <transition name="fade">
      <CreateTicket v-if="create" :edit="this.ticketToEdit" @ticket-created="onTicketCreated"/>
    </transition>

    <b-card title="Le mie Richieste" class="mt-5">
      <b-row class="mb-3">
        <b-col>
          <p>Segui lo stato di avanzamento delle tue richieste.</p>
        </b-col>
        <b-col class="text-right">
          <b-btn variant="outline-danger" @click="createTicket">
            <i class="fas fa-file-alt mr-2"></i> Nuova Richiesta
          </b-btn>
        </b-col>
      </b-row>


      <b-table striped hover :items="tickets" :fields="fields">
        <template slot="category" slot-scope="data">
          <strong>{{ data.value }}</strong>
        </template>
        <template slot="subcategory" slot-scope="data">
          <strong>{{ data.value }}</strong><br>
          <span class="font-size-12" v-if="data.item.tickets_extra">
            Prodotto di interesse:
            {{ data.item.tickets_extra.extra.product | capitalize | placeholder('-') }}
          </span>
        </template>
        <template slot="slot" slot-scope="data" class="text-secondary">
          {{ data.value.start | moment('DD/MM/YYYY HH:mm') }}
        </template>
        <template slot="created_at" slot-scope="data" class="text-secondary">
          {{ data.value | moment('DD/MM/YYYY HH:mm') }}
        </template>
        <template slot="closed_at" slot-scope="data" class="text-secondary">
          {{ data.value | moment('DD/MM/YYYY HH:mm') | placeholder('-') }}
        </template>
        <template slot="id" slot-scope="data" class="text-secondary">
          <!--
          <b-btn
            variant="link"
            @click="editTicket(data.item)"
            v-scroll-to="'#schedule'"
            :disabled="checkDisabled(data.item)">
            <i class="fas fa-edit"/>
          </b-btn>
          -->
          <b-btn
            variant="link"
            @click="undoTicket(data.item)"
            v-scroll-to="'#schedule'"
            :disabled="checkDisabled(data.item)">
            <i class="fas fa-trash-alt"></i>
          </b-btn>
        </template>
      </b-table>


      <p v-if="!tickets.length" class="text-center p3">
        Non risultano richieste aperte associate al tuo account.<br>
        Creane una da questa pagina web oppure
        <a href="/#/download">scarica l'applicazione</a> per la tua piattaforma.
      </p>

    </b-card>

    <transition name="fade">
      <Schedule/>
    </transition>

  </div>
</template>

<script>
  import EventBus from '@/services/eventbus';
  import Schedule from '@/components/plans/Schedule';
  import CreateTicket from './CreateTicket';
  import moment from 'moment';

  export default {
    name: 'Richieste',
    components: {
      Schedule, CreateTicket,
    },
    props: {
      create: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data: () => ({
      tickets: [],
      ticketToEdit: null,
      fields: [
        {
          key: 'num',
          label: 'Num.',
          sortable: true,
        },
        {
          key: 'status',
          label: 'Stato',
          sortable: true,
        },
        {
          key: 'category',
          label: 'Categoria',
          sortable: true,
        },
        {
          key: 'subcategory',
          label: 'Sub',
          sortable: true,
        },
        {
          key: 'slot',
          label: 'Appuntamento',
          sortable: true,
        },
        {
          key: 'created_at',
          label: 'Creato',
          sortable: true,
        },
        {
          key: 'closed_at',
          label: 'Chiuso',
          sortable: true,
        },
        {
          key: 'id',
          label: 'Gestisci',
          sortable: false,
        },
      ],
    }),


    mounted() {
      this.getData();
      EventBus.$on('refresh_data', this.getData);
    },

    methods: {
      async getData() {
        this.tickets = await this.$apiclient.getTickets();
      },

      createTicket() {
        this.create = true;
        this.ticketToEdit = null;
      },

      editTicket(ticket) {
        this.ticketToEdit = ticket;
        this.create = true;
      },

      onTicketCreated() {
        this.create = false;
        this.getData();
      },

      async undoTicket(ticket) {
        const confirm = await this.$swal({
          icon: 'info',
          title: 'Cancellazione Richiesta',
          text: 'Procedere con la cancellazione della richiesta?',
          buttons: ['Annulla', 'Procedi'],
        });

        if (!confirm) {
          return;
        }

        try {
          await this.$apiclient.createTicket({
            ticket: {
              ...ticket,
              revoked: true,
              status: 'Revocato',
            },
          });

          this.$swal({
            icon: 'success',
            title: 'Cancellazione Richiesta',
            text: 'Richiesta annullata correttamente.',
          });

          this.getData();
        } catch (err) {
          console.log('Creazione ticket', err);
          this.$swal('Oops', 'Si è verificato un errore nella modifica del ticket.', 'error');
        }
      },

      checkDisabled(item) {
        return item.closed || item.revoked || moment(item.slot.start).isBefore(moment().subtract(3, 'days'));
      },
    },
  };

</script>

<style>
  .btn {
    border-radius: 0.6rem;
  }

  .card {
    box-shadow: 0 3px 20px rgba(0, 0, 0, 0.1);
  }

  .fc-right h2 {
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/AreaRiservata/Richieste.vue